module.exports = __webpack_public_path__ + "img/calling.cd3842ae.svg";